import { Box, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import Services from '../Components/Services';
import LetsTalk from '../Components/LetsTalk';
import AOS from "aos";
import "aos/dist/aos.css";

function ServicesPage() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [])



    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animation happens only once
        });
    }, []);

    const servicesData = [
        {
            title: "Brand Design & UI/UX",
            navigateurl: "brand-design-uiux",
            overviewLine: "Where strategy meets striking visuals and seamless user journeys to elevate perception, boost engagement, and drive lasting impact.",
            descriptions: [
                {
                    title: "Growth Strategy",
                    description: "Defining who your next best customers are and new market opportunities.",
                },
                {
                    title: "Brand Identity",
                    description: "The visual and behavioral base code for your brand across every interaction.",
                },
                {
                    title: "Brand Foundation",
                    description: "The core tenets of your brand (purpose, positioning, principles and measurement frameworks) to guide action.",
                },
                {
                    title: "Brand AI Tools",
                    description: "AI-enabled tools to help teams deliver brand systems cohesively and efficiently at scale.",
                },
                {
                    title: "Brand Architecture",
                    description: "How to organize your brand(s) and offerings to support growth ambitions.",
                },
                {
                    title: "Brand System",
                    description: "Defining how you flex and adapt your brand across interfaces.",
                },
            ],
            images: [
                {
                    front: "/Images/Services/tandm-front.png",
                    back: "/Images/Services/tandm-back.png",
                    value: "tandm"
                },
                {
                    front: "/Images/Services/skilljobs-front.png",
                    back: "/Images/Services/skilljobs-back.png",
                    value: "skilljobs"
                },
                {
                    front: "/Images/Services/louca-front.png",
                    back: "/Images/Services/louca-back.png",
                    value: "louca"
                },
            ]
        },
        {
            title: "Website & Web Platform",
            navigateurl: "website-web-platform",
            overviewLine: "We design and develop scalable, high-performance websites and web applications that deliver seamless user experiences, strong functionality, and business-driven digital solutions.",
            descriptions: [
                {
                    title: "Responsive Web Design",
                    description: "Creating mobile-friendly and adaptive interfaces that provide a consistent experience across all devices.",
                },
                {
                    title: "Custom Web Development",
                    description: "Building tailored websites and web apps with modern frameworks to meet unique business needs.",
                },
                {
                    title: "UI/UX Design",
                    description: "Designing intuitive, user-centric interfaces that enhance engagement and usability.",
                },
                {
                    title: "E-commerce Solutions",
                    description: "Developing secure and scalable online stores with smooth checkout and payment integration.",
                },
                {
                    title: "API Integration",
                    description: "Connecting third-party services and backend systems for enhanced functionality and automation.",
                },
                {
                    title: "Performance Optimization",
                    description: "Improving speed, scalability, and overall performance for better user experience and SEO.",
                },
            ],
            images: [
                {
                    front: "/Images/Services/futsaloz-front.png",
                    back: "/Images/Services/futsaloz-back.png",
                    value: "futsaloz"
                },
                {
                    front: "/Images/Services/redarc-front.png",
                    back: "/Images/Services/redarc-back.png",
                    value: 'redarc'
                },
                {
                    front: "/Images/Services/juicelabs-front.png",
                    back: "/Images/Services/juicelabs-back.png",
                    value: "juicelabs"
                },
            ]
        },
        {
            title: "Mobile App & IoT",
            navigateurl: "mobile-app-development-services",
            overviewLine: "We develop intelligent CRM systems and customer management software that streamline sales, improve customer relationships, and automate business workflows for better efficiency and growth.",
            descriptions: [
                {
                    title: "Android & iOS App Development",
                    description: "Creating high-performance native and cross-platform mobile apps with smooth user experiences.",
                },
                {
                    title: "IoT Device Integration",
                    description: "Connecting smart devices with applications for real-time data exchange and control.",
                },
                {
                    title: "Custom Mobile Solutions",
                    description: "Developing tailored mobile apps aligned with specific business goals and workflows.",
                },
                {
                    title: "App Performance Optimization",
                    description: "Enhancing speed, stability, and responsiveness for better user engagement.",
                },
            ],
            images: [
                {
                    front: "/Images/Services/belong-front.png",
                    back: "/Images/Services/belong-back.png",
                    value: "belong"
                },
                {
                    front: "/Images/Services/tandm-front.png",
                    back: "/Images/Services/tandm-back.png",
                    value: "tandm"
                },
                {
                    front: "/Images/Services/pinch-front.png",
                    back: "/Images/Services/pinch-back.png",
                    value: "pinch"
                },
            ]
        },
        {
            title: "CRM & Custom Software",
            navigateurl: "custom-software-development-services",
            overviewLine: "We develop intelligent CRM systems and customer management software that streamline sales, improve customer relationships, and automate business workflows for better efficiency and growth.",
            descriptions: [
                {
                    title: "Custom CRM Development",
                    description: "Building tailored CRM platforms to manage leads, customers, and sales pipelines effectively.",
                },
                {
                    title: "Customer Data Management",
                    description: "Organizing and centralizing customer information for better insights and decision-making.",
                },
                {
                    title: "Sales & Lead Automation",
                    description: "Automating lead tracking, follow-ups, and sales processes to improve conversions.",
                },
                {
                    title: "Workflow Automation",
                    description: "Streamlining business operations by automating repetitive customer-related tasks.",
                },
                {
                    title: "Analytics & Reporting",
                    description: "Providing real-time dashboards and reports to track performance and customer behavior.",
                },
                {
                    title: "Third-party Integrations",
                    description: "Connecting CRM systems with tools like email, payment gateways, and marketing platforms.",
                },
            ],
            images: [
                {
                    front: "/Images/Services/wefroth-front.png",
                    back: "/Images/Services/wefroth-back.png",
                    value: "wefroth"
                },
                {
                    front: "/Images/Services/mysterymanagement-front.png",
                    back: "/Images/Services/mysterymanagement-back.png",
                    value: "mysterymanagement"
                },
                {
                    front: "/Images/Services/connexion-front.png",
                    back: "/Images/Services/connexion-back.png",
                    value: "connexion"
                },
            ]
        },
        {
            title: "AI & Machine Learning",
            navigateurl: "ai-automation-and-machine-learning-services",
            overviewLine: "We deliver AI & Machine Learning solutions that turn data into smart insights and automation, including stock analysis, conversational AI, report QA, and custom chatbots to help businesses work faster and smarter.",
            descriptions: [
                {
                    title: "Predictive analytics",
                    description: "Uncovering patterns in your data to forecast trends and support smarter business decisions.",
                },
                {
                    title: "Conversational AI",
                    description: "Building intelligent assistants and chatbots that resolve queries instantly and at scale.",
                },
                {
                    title: "Stock & investment analysis",
                    description: "Applying advanced ML models to market data for sharper, faster investment decisions.",
                },
                {
                    title: "AI-powered quality assurance",
                    description: "Automating report validation and compliance checks to ensure accuracy across operations.",
                },
                {
                    title: "Custom model development",
                    description: "Designing and training bespoke ML models tailored to your unique business problems.",
                },
                {
                    title: "Process automation",
                    description: "Eliminating repetitive manual tasks by embedding intelligent automation into your workflows.",
                },
            ],
            images: [
                {
                    front: "/Images/Services/wolfpack-front.png",
                    back: "/Images/Services/wolfpack-back.png",
                    value: "wolfpack"
                },
                {
                    front: "/Images/Services/mysterymanagement-front.png",
                    back: "/Images/Services/mysterymanagement-back.png",
                    value: "mysterymanagement"
                },
                {
                    front: "/Images/Services/betodyssey-front.png",
                    back: "/Images/Services/betodyssey-back.png",
                    value: 'betodyssey'
                },
            ]

        },
        {
            title: "Cloud Computing & DevOps ",
            navigateurl: "cloud-computing-devops",
            overviewLine: "We provide scalable cloud solutions and DevOps services that ensure faster deployments, high availability, and secure, efficient infrastructure management for modern digital businesses.",
            descriptions: [
                {
                    title: "Cloud Infrastructure Setup",
                    description: "Designing and deploying secure, scalable cloud environments tailored to business needs.",
                },
                {
                    title: "DevOps Automation",
                    description: "Implementing CI/CD pipelines to streamline development, testing, and deployment processes.",
                },
                {
                    title: "Cloud Migration Services",
                    description: "Seamlessly migrating applications and data to cloud platforms with minimal downtime.",
                },
                {
                    title: "Scalable Architecture Design",
                    description: "Building flexible systems that scale efficiently with business growth and demand.",
                },
                {
                    title: "Monitoring & Performance Optimization",
                    description: "Ensuring system reliability through continuous monitoring and performance tuning.",
                },
                {
                    title: "Security & Compliance Management",
                    description: "Implementing best practices to protect data, applications, and cloud infrastructure.",
                },
            ],
            images: [
                {
                    front: "/Images/Services/wolfpack-front.png",
                    back: "/Images/Services/wolfpack-back.png",
                    value: "wolfpack"
                },
                {
                    front: "/Images/Services/mysterymanagement-front.png",
                    back: "/Images/Services/mysterymanagement-back.png",
                    value: "mysterymanagement"
                },
                {
                    front: "/Images/Services/wefroth-front.png",
                    back: "/Images/Services/wefroth-back.png",
                    value: "wefroth"
                },
            ]
        },
        {
            title: "SEO & Search Marketing",
            navigateurl: "seo-services",
            overviewLine: "We improve your visibility in search with technical SEO, content and local search strategies that bring qualified traffic and leads to your business.",
            descriptions: [
                {
                    title: "Technical SEO",
                    description: "Improving speed, structure and crawlability so search engines can find and rank your pages.",
                },
                {
                    title: "Content & On-Page SEO",
                    description: "Building search-focused pages and content around the terms your customers use.",
                },
                {
                    title: "Local SEO",
                    description: "Strengthening your Google Business Profile and local presence across Melbourne and Australia.",
                },
                {
                    title: "Analytics & Reporting",
                    description: "Tracking rankings, traffic and leads with clear monthly reporting.",
                },
            ],
            images: [
                {
                    front: "/Images/Services/mysterymanagement-front.png",
                    back: "/Images/Services/mysterymanagement-back.png",
                    value: "mysterymanagement"
                },
                {
                    front: "/Images/Services/futsaloz-front.png",
                    back: "/Images/Services/futsaloz-back.png",
                    value: "futsaloz"
                },
                {
                    front: "/Images/Services/redarc-front.png",
                    back: "/Images/Services/redarc-back.png",
                    value: "redarc"
                },
            ]
        },
        {
            title: "Social Media Marketing",
            navigateurl: "social-media-marketing-services",
            overviewLine: "We plan, create and manage social media marketing that builds your brand, engages your audience and drives enquiries.",
            descriptions: [
                {
                    title: "Social Strategy & Content",
                    description: "Creating on-brand content and a clear strategy for the platforms your audience uses.",
                },
                {
                    title: "Community Management",
                    description: "Responding to comments and messages and building relationships with your audience.",
                },
                {
                    title: "Paid Social Advertising",
                    description: "Running targeted campaigns on Meta and LinkedIn with creative testing and conversion tracking.",
                },
                {
                    title: "Reporting & Optimisation",
                    description: "Measuring reach, engagement and leads, and improving results every month.",
                },
            ],
            images: [
                {
                    front: "/Images/Services/wefroth-front.png",
                    back: "/Images/Services/wefroth-back.png",
                    value: "wefroth"
                },
                {
                    front: "/Images/Services/juicelabs-front.png",
                    back: "/Images/Services/juicelabs-back.png",
                    value: "juicelabs"
                },
                {
                    front: "/Images/Services/louca-front.png",
                    back: "/Images/Services/louca-back.png",
                    value: "louca"
                },
            ]
        },
    ];

    return (
        <Box mt={{ xs: 8, md: 4, lg: 5 }}>
            <Typography data-aos="fade-up" gutterBottom className='fs-64 text-center bold-text'><span className='text-color-main'>CRAFTING SOLUTIONS</span> <br /> <span className='text-light-main'>THAT MATTER</span></Typography>

            <Box className='mt-2'>
                <Services services={servicesData} isNavigate={true} />
            </Box>
            <Box className='mt-5'>
                <LetsTalk />
            </Box>
        </Box>
    )
}

export default ServicesPage
